export default __webpack_public_path__ + "static/media/firefox-icon.08c932a4.png";